<template>
  <div class="data_chartmain">
    <Header />
    <div class="databox"></div>
    <Logo />
  </div>
</template>

<script>
import Header from '../Header.vue';
import Logo from '../Logo.vue';
//
export default {
  name: 'index',
  components: {
    Header,
    Logo,
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped></style>
